<template>
  <!-- template for the modal component -->
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              Error
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <p />
              Some error occured.
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button" @click="$emit('close')">
                Close
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "error-popup"
};
</script>

<style lang="scss">
@import "../styles/_variables.scss";

.modal-mask {
  position: fixed;
  z-index: 30;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 350px;
  border-radius: 0.1875rem;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  padding-bottom: 8px;
  text-align: center;
  color: $accentColor;
}

.modal-body {
  margin: 5px;
  padding-bottom: 22px;
  //padding 5px 10px
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 5px;
}

.modal-default-button {
  width: auto;
  font-size: 1rem;
  font-weight: 500;
  font-family: "Open Sans", sans-serif;
  border-color: $secondaryColor;
  background-color: $secondaryColor;
  height: 2.3125rem;
  padding: 0 0.625rem;
  border-radius: 0.1875rem;
  box-shadow: 0 0.5625rem 2.4375rem -0.6875rem rgba(0, 0, 0, 0.75);
  min-width: 0;
  color: white;
}

/*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1);
  transform: scale(1);
}
</style>
